<script>
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        idkompetensi: null,
        nama_kompetensi: "",
        id_mprofesi: null,
        nama_profesi: "",
      },
      type: "",
      kompetensiOption: [],
      profesiOption: [],
      dahanProfesiOption: [],
    };
  },
  props: ["typeTrans", "dataKompetensiProfesi"],
  watch: {
    dataKompetensiProfesi: function (newVal) {
      if (newVal == null) {
        this.formData = {
          idkompetensi: null,
          nama_kompetensi: "",
          id_mprofesi: null,
          nama_profesi: "",
        };
      } else {
        this.formData = {
          idkompetensi: newVal.idkompetensi,
          nama_kompetensi: newVal.nama_kompetensi,
          id_mprofesi: newVal.id_mprofesi,
          nama_profesi: newVal.profesi?.nama_profesi,
        };
      }
      this.getKompetensi();
      this.getProfesi();
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url = this.typeTrans == "add" ? "master/kompetensi-profesi" : "master/kompetensi-profesi/" + this.formData.idkompetensi;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (!this.formData.nama_kompetensi || !this.formData.id_mprofesi) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensi(search, loading);
      }
    },
    async getKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 100,
              // col: ["nama_kompetensi", "idkompetensi"],
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.kompetensiOption = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchProfesi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getProfesi(search, loading);
      }
    },
    async getProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.profesiOption = response.data.data;
          if (loading) loading(false);
        });
    },
  },
  mounted() {
    this.getKompetensi();
    this.getProfesi();
    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kompetensi" class="form-label">Kompetensi</label>
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="kompetensiOption"
          :reduce="(item) => item.nama_kompetensi"
          label="nama_kompetensi"
          v-model="formData.nama_kompetensi"
          placeholder="Kompetensi"
          @search="filterKompetensi"
          :disabled="typeTrans == 'edit'"
        >
        </v-select>
      </div>
      <div class="form-group mb-3">
        <label for="profesi" class="form-label">Profesi</label>
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="profesiOption"
          :reduce="(item) => item.id_mprofesi"
          label="nama_profesi"
          v-model="formData.id_mprofesi"
          placeholder="Profesi"
          @search="filterProfesi"
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
